import { ca } from '../i18n/ca';
import { promptInstall, useInstallWay } from './installPrompt';

/**
 * Where the navigation is (the rail, and the phone's «Més» sheet), the way to
 * install the app on this browser (`installPrompt.ts`): a button where the
 * browser can open its own dialog, the share sheet's path on an iPhone, and
 * nothing once installed or where neither exists.
 */
export function InstallOffer() {
  const way = useInstallWay();
  const t = ca.installApp;
  if (way === 'prompt') {
    return (
      <button type="button" className="navitem install-offer" onClick={() => void promptInstall()}>
        <i className="bi bi-download" aria-hidden="true" />
        <span>{t.button}</span>
      </button>
    );
  }
  if (way === 'ios') {
    return (
      <p className="install-hint small">
        <i className="bi bi-box-arrow-up" aria-hidden="true" />
        <span>
          {t.ios} <strong>{t.iosSteps}</strong>
        </span>
      </p>
    );
  }
  return null;
}
